/** 按需引入echarts */
import * as echarts from "echarts/core";
import ecStat from "echarts-stat";
import { ScatterChart } from "echarts/charts";
import { GridComponent, DatasetComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
echarts.registerTransform(ecStat.transform.regression);
echarts.use([GridComponent, DatasetComponent, ScatterChart, CanvasRenderer]);
export default echarts;
